import {useMutation, useQuery, gql} from "@apollo/client";
import {LoginButton, LogoutButton} from './Auth';
import {useAuth0} from "@auth0/auth0-react";
import {BlogPost, Blog} from "./Blog";
import {ToDo, ToDoList} from "./ToDoList"
import React, {useState} from 'react';

const GET_POST = 
  gql`
    query GetPost($id:Int! ) {
      posts(where: {id: $id}) {
        body
        date
        id
        title
      }
    }
  `;

const INSERT_POST = 
  gql`
    mutation InsertPost($body: String!, $title: String!) {
      insert_posts_one(object: {body: $body, title: $title}) {
        body
        date
        title
        author_id
      }
    }
  `;

const INSERT_TODO = 
  gql `
    mutation InsertTodo ($body: String!, $title: String!) {
      insert_todos_one(object: {body: $body, title: $title}) {
        body
        title
      }
    }
  `;

const PostForm = (props) => {
  const newPost = {
    title: "",
    body: "",
    date: Date(Date.now()).toLocaleString()
  }

  const [thisPost, setThisPost] = useState(newPost);


  const [insertPost] = useMutation(INSERT_POST);
  
  const handlePostSubmit = (event) => {
    //console.log(thisPost);
    event.preventDefault();
    insertPost({
      variables: {
        title: thisPost.title,
        body: thisPost.body
      }
    });
  }

  const handlePostChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const update = {[name]: value, date: Date(Date.now()).toLocaleString() };

    const newPost = Object.assign({}, thisPost, update);
    setThisPost(newPost)  ;
  }

  return(
    <div>
      <form onSubmit = {handlePostSubmit}>
        <label>Post Title</label><br />
        <input 
          type="text" 
          name="title" 
          value={thisPost.title} 
          onChange={handlePostChange} 
          required />
        <br />
        <label>Post Body</label><br />
        <textarea name="body" 
          rows="10" 
          cols="60" 
          value = {thisPost.body}
          onChange={handlePostChange}
          required />
        <br />
        <button type="submit">Post</button>

      </form>

      <BlogPost {...thisPost} />
      <Blog admin="true" />
    </div>
  )
}

const ToDoForm = (props) => {
  const handleTodoChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const update = {[name]: value, date: Date(Date.now()).toLocaleString()};

  }
  const handleTodoSubmit = (event) => {
    event.preventDefault();
    const target = event.target;
    console.log(target);
  }
  return(
    <div >
      <form onSubmit = {handleTodoSubmit}>
        <label>Todo Title</label><br/>
        <input 
          name="title"
          type="text"
          onChange={handleTodoChange}
          required 
          /> <br/>
        <label>Todo Body</label><br/>
        <input 
          name="body"
          type="text"
          rows="5"
          cols="40"
          onChange={handleTodoChange}
          required
          />
        <input type="submit" />
      </form>
    </div>
  )

}

const handleEdit = (id) => {
  console.log("edit " + id);
}
const handleDelete = (id) => {
  console.log("delete " + id);
}

const EditDeleteButtons = (props) => {
  const {isAuthenticated} = useAuth0();
  
    if (isAuthenticated) {
      return ( 
        <div>
          <button onClick={() => handleEdit(props.id)}>Edit</button>
          <button onClick={() => handleDelete(props.id)}>Delete</button>
        </div>
      )
    }
    else {
      return;
    }
}

const SaveCancelButtons = () => {
  const {isAuthenticated} = useAuth0();
    if (isAuthenticated) {
      return (
        <div>
          <button>Save</button>
          <button>Delete</button>
        </div>
      );
    } else {
      return;
    }
}

const Admin = () => {
  const {isAuthenticated } = useAuth0();

  return( 
    (isAuthenticated && (
      <div className="centerBox">
        <div>
        <h1>Admin!</h1> 
        <ToDoForm />
        <PostForm />
        <LogoutButton />
        </div>

      </div>
    )) || <LoginButton />

  );
}



export {EditDeleteButtons, SaveCancelButtons};
export default Admin;

